import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon } from 'lucide-react';
import { essentialTools } from '../data/tools';
export function ToolsSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-319" data-mp="3njahikfs1x2c">
      <div className="max-w-5xl mx-auto" data-id="element-320" data-mp="3ni0h3olgccsj">
        <div className="text-center mb-16" data-id="element-321" data-mp="3nl4rj3pig4rn">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-deep mb-3" data-id="element-322" data-mp="3jiro4ly8kiy1">
            The <span className="text-gold" data-id="element-323" data-mp="2vrcjgmizlpjm">2 Essential Teaching Tools</span>
          </h2>
          <p className="text-lg text-navy-mid" data-id="element-324" data-mp="2qtkotkqyjpbq">
            Included as part of the 6-in-1 system — not sold separately
            anywhere.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-325" data-mp="34qg2jqi5m4y4">
          {essentialTools.map((tool, index) => <motion.article key={tool.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card border border-gold-light rounded-2xl p-8 shadow-sm flex flex-col" data-id="element-326" data-mp="2zw2a9wysgdxo" data-mpi={index}>
              <div className="w-12 h-12 bg-navy-deep rounded-full flex items-center justify-center text-gold-light mb-6" data-id="element-327" data-mp="2m62hfbex9l7q">
                <WrenchIcon size={22} data-id="element-328" data-mp="2r4ni1by366wp" />
              </div>
              <div className="text-gold font-bold text-sm uppercase tracking-wider mb-1" data-id="element-329" data-mp="2w4s2te611nsq">
                🔧 {tool.label}
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 text-navy-deep" data-id="element-330" data-mp="1yfzvld1lpbhk">
                {tool.title}
              </h3>
              <p className="text-navy-mid text-sm italic mb-5 border-l-2 border-gold pl-4" data-id="element-331" data-mp="28gijqk077e5a">
                {tool.subtitle}
              </p>
              <div className="space-y-4 mb-6 flex-grow" data-id="element-332" data-mp="2d8jsvx22kor3">
                {tool.paragraphs.map(paragraph => <p key={paragraph} className="text-ink text-sm leading-relaxed" data-id="element-333" data-mp="1frbc8virne7w">
                    {paragraph}
                  </p>)}
              </div>
              <p className="text-forest-deep text-sm font-semibold bg-forest-soft border border-forest/30 rounded-xl p-4" data-id="element-334" data-mp="1conn8595ec3u">
                {tool.benefit}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}